var render = function render(){var _vm=this,_c=_vm._self._c;return _c('generic-selector',{attrs:{"item-key":"deveui","item-label":"name","items":_vm.tags,"title":_vm.$t('tag.choose')},model:{value:(_vm.localTag),callback:function ($$v) {_vm.localTag=$$v},expression:"localTag"}})
}
var staticRenderFns = []

export { render, staticRenderFns }